import { Settings } from "../../Settings";
import { ITitleGeneric } from "./ITitleGeneric";
import { jackpotTitleSlide } from "./jackpotTitleSlide";
import { titleGame } from "./titleGame";
import { titleParamsFeature } from "./titleParamsFeature";

export interface ITitleGenericFactory{
    CreateTitleFactory(params : titleParamsFeature):ITitleGeneric
}

export class TitleFactory implements ITitleGenericFactory { 
    public CreateTitleFactory(params : titleParamsFeature) : ITitleGeneric{
        if(Settings.titleGameSlide == false){
            return new titleGame(params)
        }
        else{
            return new  jackpotTitleSlide(params)
        }
    }
}